module.exports = __webpack_public_path__ + "img/product_24.afa4c85.jpg";